import "@fontsource-variable/geist";
import "@fontsource-variable/geist-mono";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router";
import { Providers } from "@/components/providers";
import { NotFound } from "@/components/app/states";
import { AppLayout, AuthOnlyLayout, PublicOnly } from "@/pages/layouts";
import { AuthPage } from "@/pages/auth";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/password-reset";
import { DashboardPage } from "@/pages/dashboard";
import { ExerciseDetailPage, NewExercisePage } from "@/pages/exercises/detail";
import { ExercisesPage } from "@/pages/exercises/list";
import { LandingPage } from "@/pages/landing";
import { PlanPage } from "@/pages/plans/plan";
import { PlansPage } from "@/pages/plans/list";
import { SharedPlanPage } from "@/pages/plans/shared";
import { WorkoutPage } from "@/pages/plans/workout";
import { ProfilePage } from "@/pages/profile";
import { ExerciseProgressPage } from "@/pages/progress/exercise";
import { ProgressPage } from "@/pages/progress/overview";
import { SessionPage } from "@/pages/progress/session";
import { TrainPage } from "@/pages/train/page";
import { registerServiceWorker } from "@/lib/offline";

registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Providers>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicOnly />}>
            <Route index element={<LandingPage />} />
            <Route path="login" element={<AuthPage mode="login" />} />
            <Route path="register" element={<AuthPage mode="register" />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
          </Route>
          {/* Also reachable when signed in (the link from the mail may open in a signed-in browser). */}
          <Route path="reset-password" element={<ResetPasswordPage />} />
          <Route element={<AppLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="plans" element={<PlansPage />} />
            <Route path="plans/:planId" element={<PlanPage />} />
            <Route path="plans/:planId/workouts/:workoutId" element={<WorkoutPage />} />
            <Route path="shared/:token" element={<SharedPlanPage />} />
            <Route path="exercises" element={<ExercisesPage />} />
            <Route path="exercises/new" element={<NewExercisePage />} />
            <Route path="exercises/:exerciseId" element={<ExerciseDetailPage />} />
            <Route path="progress" element={<ProgressPage />} />
            <Route path="progress/exercise/:exerciseId" element={<ExerciseProgressPage />} />
            <Route path="progress/session/:sessionId" element={<SessionPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
          <Route element={<AuthOnlyLayout />}>
            <Route path="train/:sessionId" element={<TrainPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Providers>
  </StrictMode>,
);
